exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".verify-step3[data-v-1fab1279]{display:-webkit-box;display:-ms-flexbox;display:flex;padding-top:120px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:calc(100vh - 270px);color:#72dca6}.tips[data-v-1fab1279]{margin-top:20px}", ""]);

// exports
